module.exports = "/fast-coin/img/coin/coin_dice_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/coin_dice_1.png
// module id = 2378
// module chunks = 5